import React, { useEffect, useMemo, useRef, useState } from 'react';

export function AdminPagedTbody(props: {
  rows: React.ReactNode[];
  pageSize?: number;
  unit?: string;
}) {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(props.pageSize || 20);
  const total = props.rows.length;
  const totalPages = Math.max(1, Math.ceil(total / size));
  const safePage = Math.min(page, totalPages);
  useEffect(function () { setPage(1); }, [total]);
  const paged = useMemo(function () {
    return props.rows.slice((safePage - 1) * size, safePage * size);
  }, [props.rows, safePage, size]);
  const tdRef = useRef<HTMLTableCellElement | null>(null);
  const [cols, setCols] = useState(0);
  useEffect(function () {
    if (!tdRef.current) return;
    const table = tdRef.current.closest('table');
    const head = table && table.querySelector('thead tr:last-child');
    if (head && head.children.length) setCols(head.children.length);
  }, [total, safePage]);
  return (
    <tbody>
      {paged}
      {total > size ? (
        <tr>
          <td ref={tdRef} colSpan={cols || 1} style={{ padding: '10px 12px', background: '#fff' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', fontSize: 12, color: 'var(--brand-text-muted)' }}>
              <span>{'共 ' + total + ' ' + (props.unit || '条')}</span>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <select className="input" style={{ width: 72, height: 28, padding: '2px 6px', fontSize: 12 }} value={size}
                  onChange={(e) => setSize(Number(e.target.value))}>
                  {[20, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
                </select>
                <button type="button" className="btn btn-xs btn-outline" disabled={safePage <= 1} onClick={() => setPage(safePage - 1)}>上一页</button>
                <span style={{ minWidth: 88, textAlign: 'center' }}>{'第 ' + safePage + ' / ' + totalPages + ' 页'}</span>
                <button type="button" className="btn btn-xs btn-outline" disabled={safePage >= totalPages} onClick={() => setPage(safePage + 1)}>下一页</button>
              </span>
            </div>
          </td>
        </tr>
      ) : null}
    </tbody>
  );
}
